// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"yr-z","breadcrumbForward":"zr-z","breadcrumbBack":"Ar-z","selected":"Br-z"};